import { Instance } from 'mobx-state-tree';
import { Secretariat } from '../store/models';
import { uphocLogo, applLogo, cerpanLogo } from '../assets';

export const getSecretariatLogo = (secretariat: Instance<typeof Secretariat> | undefined) => {
  if (secretariat !== undefined && secretariat.code !== undefined) {
    switch (secretariat.code) {
      case 'APPL':
        return applLogo;
      case 'CERPAN':
        return cerpanLogo;
      case 'UPHOC':
      default:
        return uphocLogo;
    }
  }
  return uphocLogo;
};
